export default __webpack_public_path__ + "static/media/photo--lg--76.76fbb54c.jpg";